import { useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import useCategoriaOrdenStore from "../../store/categoriaOrdenStore";
import Loader from "../../components/Loader";
import { ReactSortable } from "react-sortablejs";
import SelectMultiForm from '../../components/SelectMultiForm';

const CategoriaOrden = () => {

  const { isLoading, iniciar, sucursales, sucursalesOrden, categoriasOrdenTemp, handleCategoriasOrden, handleSucursales, handleSave } = useCategoriaOrdenStore();
    useEffect(() => {
    iniciar();
  }, []);
  
  return (
    <>
      <MasterLayout>
        {
          isLoading ?
          <Loader /> :
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Categoría Orden</h4>
                  <button className="btn btn-primary" onClick={handleSave}>Guardar</button>
                </div>
                <div className="card-body">
                  <SelectMultiForm
                    col="col-sm-12"
                    datos={sucursales} 
                    change={handleSucursales}
                    values={sucursalesOrden}
                    placeholder="Seleccione una o varias sucursales"
                    name="sucursalesOrden"
                    isMulti={false}
                  />
                  <ReactSortable 
                      list={categoriasOrdenTemp.filter(categoria => categoria.ID_SUC == sucursalesOrden[0].value)} 
                      setList={handleCategoriasOrden} 
                      className="row gap-4 d-flex justify-content-center"
                    >
                        {
                          categoriasOrdenTemp.filter(categoria => categoria.ID_SUC == sucursalesOrden[0].value).map((categoria, index) => (
                            <div key={categoria.ID_CP} className="col-3 card bg-white rounded-lg p-1" >
                              <h2 className="text-xl font-bold mb-2">{index + 1}. {categoria.NOMBRE_CP}</h2>
                            </div>
                          ))
                        }
                    </ReactSortable>
                </div>
              </div>
            </div>
          </div>
        }
      </MasterLayout>
    </>
  );
};

export default CategoriaOrden;